import { ReactElement, useEffect, useRef, useState } from 'react'
import {
    QrImage,
    QRLogoWrapper,
    QrScanner,
    QrScannerWrapper
} from './subcomponent'
import QRLOGO from '../../../assets/qr.png'
import {
    ActionButton,
    FlexWrapper,
    PageWrapper,
    SectionTitle
} from '../../../components'
import { useDispatch } from 'react-redux'
import strings from '../../../locale/en'
import { getQrIdByScan } from '../../../redux/studentQrCode/api'
import useBreakpoint from 'use-breakpoint'
import BREAKPOINTS from '../../../const/breakpoint'

const WebCamScanner = (): ReactElement => {
    const dispatch = useDispatch()
    const qrRef = useRef(null);

    const [scanResultWebCam, setScanResultWebCam] = useState<any>('')
    const [show, setshow] = useState(false)
    const [button, setbutton] = useState('')
    const { breakpoint } = useBreakpoint(BREAKPOINTS)
    const {
        studentQR: { orScanner, qrLogoAlt, pleaseWait, buttonClick }
    } = strings

    const handleScanWebCam = (result: any) => {
        if (result) {
            setScanResultWebCam(result.data)
        }
    }

    const handleError = (error: any) => {
        console.log(error)
    }

    useEffect(() => {
        setbutton(scanResultWebCam)
    }, [scanResultWebCam])

    useEffect(() => {
        if (button !== '') {
            dispatch(getQrIdByScan(scanResultWebCam))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [button])

    return (
        <PageWrapper>
            <FlexWrapper hasBorder >
                <SectionTitle title={orScanner} />
            </FlexWrapper>
            <FlexWrapper justifyContent="center" >
                <QRLogoWrapper>
                    {show ? (
                        <QrScannerWrapper>
                            <QrScanner
                                ref={qrRef}
                                delay={300}
                                style={breakpoint === 'mobile' ? { width: '90%' } : { width: '30%' }}
                                legacyMode
                                onError={handleError}
                                onScan={handleScanWebCam} 
                            />
                        </QrScannerWrapper>
                    ) : (
                        <QrImage src={QRLOGO} alt={qrLogoAlt} />
                    )}
                </QRLogoWrapper>
            </FlexWrapper> 
            <FlexWrapper noPadding noMargin justifyContent="center">
                <ActionButton
                    style={{ border: 'none' }}
                    onClick={() => {
                        setshow(true)
                    }}
                >
                    {show ? (button !== '' ? pleaseWait : pleaseWait) : buttonClick}
                </ActionButton>
            </FlexWrapper>
        </PageWrapper>
    )
}

export default WebCamScanner
